import { ReactNode } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns'

import AuthProvider from './auth-provider'
import ChatProvider from './chat-provider'
import FolderTreeProvider from './folder-tree-provider'
import MuiThemeProvider from './mui-theme-provider'
import SnackbarNotificationProvider from './snackbar-provider'

const AllProviders = ({ children }: { children: ReactNode[] | ReactNode }) => {
  return (
    <SnackbarNotificationProvider>
      <ChatProvider>
        <AuthProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <FolderTreeProvider>
              <MuiThemeProvider>{children}</MuiThemeProvider>
            </FolderTreeProvider>
          </LocalizationProvider>
        </AuthProvider>
      </ChatProvider>
    </SnackbarNotificationProvider>
  )
}

export default AllProviders
